module.exports = __webpack_public_path__ + "static/media/55_000046.859e1b90.jpg";